export const INPUT_TEXT_DISPLAY_NAME = "InputText";
